import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Logout = loadable(() => pMinDelay(import('./Logout'), 0), {
  fallback: <Loading />
});

const AsyncLogout = props => {
  const pageConfig = {
    headerType: 'simple',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Logout { ...props } />
    </ApplicationLayout>
  );
};

AsyncLogout.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLogout;
